var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.7 33.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffc127;\n      }\n\n      .st1 {\n        fill: #dd800f;\n      }\n\n      .st2 {\n        fill: #ffd83b;\n      }\n\n      .st3 {\n        fill: #fca816;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st1",
    d: "M19.1.7l3.5,9c.1.3.3.6.6.9.3.2.6.3.9.4l8.6.9c1,.2,1.4,1.5.7,2.3l-6.5,6.1c-.5.5-.8,1.3-.6,2l1.9,9.9c.2,1.1-.3,1.6-1.4,1.6h-2c-.3-.2-6.4-5.4-6.7-5.4s-.6,0-.9.3l-7.5,4.9q-.3.2-2,.2h-.9c.1-.8,3-13,2.5-13.5l-6.5-6.1c-.7-.8-.3-2.1.7-2.3l8.6-.9c.3,0,.6-.2.9-.4.3-.2,2.7-10.3,2.9-10.6h1.2q1.9,0,2.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    className: "st2",
    d: "M16.8.7l3.5,9c.1.3.3.6.6.9.3.2.6.3.9.4l8.6.9c1,.2,1.4,1.5.7,2.3l-6.5,6.1c-.5.5-.8,1.3-.6,2l1.9,9.9c.2,1.1-.8,1.9-1.7,1.4l-7.5-4.9c-.3-.2-.6-.3-.9-.3s-.6,0-.9.3l-7.5,4.9c-.9.5-1.9-.3-1.7-1.4l1.9-9.9c.1-.8,0-1.5-.6-2L.4,14.2c-.7-.8-.3-2.1.7-2.3l8.6-.9c.3,0,.6-.2.9-.4.3-.2.5-.5.6-.9L14.6.7c.4-1,1.7-1,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    className: "st0",
    d: "M16.3,19.2c5.8-4.4,9.7-2.3,10.3-2.2l-3.9,4.2,1.7,11.2-9.3-5-8.1,5,1.8-10.9c3.8,1.4,5.4-.7,7.6-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29_",
    className: "st3",
    d: "M21.8,11c-.3,0-.6-.2-.9-.4-.3-.2-.5-.5-.6-.9L16.8.7c-.4-1-1.7-1-2.1,0l-3.5,9c-.1.3-.3.6-.6.9-.3.2-.6.3-.9.4l-8.6.9c-1,.2-1.4,1.5-.7,2.3l6.5,6.1c.5.5.8,1.3.6,2l-1.9,9.9c-.2,1.1.9,1.9,1.7,1.4l7.5-4.9c.3-.2.6-.3.9-.3s.6,0,.9.3l7.5,4.9c.9.5,1.9-.3,1.7-1.4l-1.9-9.9c-.1-.8,0-1.5.6-2l6.5-6.1c.7-.8.3-2.1-.7-2.3l-8.6-.9ZM28.1,14.5c.4-.3.1-.9-.3-1l-6.1-.6c-.7,0-1.3-.3-1.8-.8-.5-.4-.9-1-1.2-1.6,0,0,0,0,0,0l-2.5-6.3c-.2-.5-.9-.5-1,0l-2.5,6.3s0,0,0,0c-.2.6-.7,1.2-1.2,1.6-.5.4-1.1.7-1.8.8h0s-6.1.6-6.1.6c-.5,0-.7.6-.3,1l4.6,4.4c1,1,1.4,2.4,1.2,3.8h0s-1.4,7.3-1.4,7.3c0,.5.4.8.9.6l5.2-3.4s0,0,0,0c0,0,0,0,0,0,.6-.4,1.2-.6,1.8-.6s1.3.2,1.8.6c0,0,0,0,0,0l5.2,3.4c.4.3,1,0,.9-.6l-1.4-7.3s0,0,0,0c-.3-1.4.2-2.9,1.2-3.8,0,0,0,0,0,0l4.6-4.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingStar);
export default __webpack_public_path__ + "static/media/ranking_star.d3e44f124eb8813f067e3484c8471f77.svg";
export { ForwardRef as ReactComponent };